var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":_vm.message}},[_vm._v("Reset Message")]),_c('button',{on:{"click":_vm.room}},[_vm._v("Reset Room")])])}
var staticRenderFns = []

export { render, staticRenderFns }